















































































import Vue from "vue";

/**
 * Renders the field.
 */
export default Vue.extend({
  name: "GrapherField",
  computed: {
    hashMarkOffsetsY(): [number, number] {
      return [
        this.$store.getters.getFrontHashOffsetY,
        this.$store.getters.getBackHashOffsetY,
      ];
    },
    yardLineOffsetsX(): number[] {
      const middleOfField = this.$store.getters.getMiddleOfField;
      const yardLineOffsetsX: number[] = [];
      let x = 16;
      for (let lineNum = 0; lineNum < middleOfField; lineNum += 5) {
        yardLineOffsetsX.push(x);
        x += 8;
      }
      for (let lineNum = middleOfField; lineNum >= 0; lineNum -= 5) {
        yardLineOffsetsX.push(x);
        x += 8;
      }
      return yardLineOffsetsX;
    },
    fourStepGrid(): boolean {
      return this.$store.state.fourStepGrid;
    },
    yardlines(): boolean {
      return this.$store.state.yardlines;
    },
    yardlineNumbers(): boolean {
      return this.$store.state.yardlineNumbers;
    },
    showField(): boolean {
      return this.$store.state.showField;
    },
    fieldWidth(): number {
      // Account for endzones + area between yard lines
      return 16 + 8 * (this.yardLineOffsetsX.length - 1) + 16;
    },
    fieldHeight(): number {
      return (
        this.$store.getters.getBackHashOffsetY +
        this.$store.getters.getFrontHashOffsetY
      );
    },
    fourStepGridOffsetsX(): number[] {
      const offset: number = this.$store.state.yardlines ? 8 : 4;
      const retVal: number[] = [4, 8, this.fieldWidth - 8, this.fieldWidth - 4];
      for (
        let offsetX = 12;
        offsetX <= this.fieldWidth - 12;
        offsetX += offset
      ) {
        retVal.push(offsetX);
      }
      return retVal;
    },
    fourStepGridOffsetsY(): number[] {
      const retVal: number[] = [];
      for (let offsetY = 4; offsetY < this.fieldHeight; offsetY += 4) {
        retVal.push(offsetY);
      }
      return retVal;
    },
    yardLineNumberAndOffsetX(): [string, number][] {
      const retVal: [string, number][] = [];
      let yardLineNumber = 1;
      for (
        let lineIndex = 2;
        lineIndex < this.yardLineOffsetsX.length / 2;
        lineIndex += 2
      ) {
        retVal.push([
          `${yardLineNumber.toString()} 0`,
          this.yardLineOffsetsX[lineIndex],
        ]);
        const oppositeLineIndex = this.yardLineOffsetsX.length - 1 - lineIndex;
        if (oppositeLineIndex !== lineIndex) {
          retVal.push([
            `${yardLineNumber.toString()} 0`,
            this.yardLineOffsetsX[oppositeLineIndex],
          ]);
        }
        yardLineNumber += 1;
      }
      return retVal;
    },
  },
});
